import Api from './api';

// Listar webhooks com paginacao e filtros
export const getWebhooks = async (page = 1, search = '', field = '') => {
    let data = { success: false, data: [], count: 0 };
    let url = `/webhooks/paginate?page=${page}`;

    if (search && field) {
        url += `&search=${encodeURIComponent(search)}&field=${field}`;
    }

    await Api.get(url)
        .then(result => {
            data = result.data;
        })
        .catch(err => {
            data = err.response ? err.response.data : { success: false, errors: [err.message] };
        });
    return data;
};

// Buscar webhook por ID
export const getWebhookById = async (id) => {
    let data = { success: false, data: null };
    await Api.get(`/webhooks/${id}`)
        .then(result => {
            data = result.data;
        })
        .catch(err => {
            data = err.response ? err.response.data : { success: false, errors: [err.message] };
        });
    return data;
};

// Criar webhook
export const createWebhook = async (webhookData) => {
    let data = { success: false, data: null };
    await Api.post('/webhooks', webhookData)
        .then(result => {
            data = result.data;
        })
        .catch(err => {
            data = err.response ? err.response.data : { success: false, errors: [err.message] };
        });
    return data;
};

// Atualizar webhook
export const updateWebhook = async (id, webhookData) => {
    let data = { success: false, data: null };
    await Api.put(`/webhooks/${id}`, webhookData)
        .then(result => {
            data = result.data;
        })
        .catch(err => {
            data = err.response ? err.response.data : { success: false, errors: [err.message] };
        });
    return data;
};

// Excluir webhook
export const deleteWebhook = async (id) => {
    let data = { success: false };
    await Api.delete(`/webhooks/${id}`)
        .then(result => {
            data = result.data;
        })
        .catch(err => {
            data = err.response ? err.response.data : { success: false, errors: [err.message] };
        });
    return data;
};

// Ativar/Desativar webhook (usa update parcial)
export const toggleWebhookActive = async (id, isActive) => {
    let data = { success: false };
    await Api.put(`/webhooks/${id}`, { isActive })
        .then(result => {
            data = result.data;
        })
        .catch(err => {
            data = err.response ? err.response.data : { success: false, errors: [err.message] };
        });
    return data;
};

// Pausar webhook
export const pauseWebhook = async (id, reason = '') => {
    let data = { success: false };
    await Api.post(`/webhooks/${id}/pause`, { reason })
        .then(result => {
            data = result.data;
        })
        .catch(err => {
            data = err.response ? err.response.data : { success: false, errors: [err.message] };
        });
    return data;
};

// Retomar webhook pausado
export const resumeWebhook = async (id) => {
    let data = { success: false };
    await Api.post(`/webhooks/${id}/resume`)
        .then(result => {
            data = result.data;
        })
        .catch(err => {
            data = err.response ? err.response.data : { success: false, errors: [err.message] };
        });
    return data;
};

// Testar webhook existente (por ID)
export const testWebhook = async (id, eventTypeCode, payload = null) => {
    let data = { success: false, data: null };
    await Api.post(`/webhooks/${id}/test`, { eventTypeCode, payload })
        .then(result => {
            data = result.data;
        })
        .catch(err => {
            data = err.response ? err.response.data : { success: false, errors: [err.message] };
        });
    return data;
};

// Testar webhook por configuracao (para webhooks nao salvos)
export const testWebhookByConfig = async (webhookConfig, eventTypeCode, payload = null) => {
    let data = { success: false, data: null };
    await Api.post('/webhooks/test-config', {
        webhookConfig,
        eventTypeCode,
        payload
    })
        .then(result => {
            data = result.data;
        })
        .catch(err => {
            data = err.response ? err.response.data : { success: false, errors: [err.message] };
        });
    return data;
};

// Listar tipos de eventos disponiveis
export const getEventTypes = async () => {
    let data = { success: false, data: [] };
    await Api.get('/webhook-event-types')
        .then(result => {
            data = result.data;
        })
        .catch(err => {
            data = err.response ? err.response.data : { success: false, errors: [err.message] };
        });
    return data;
};

// Buscar logs de entrega do webhook
export const getWebhookDeliveryLogs = async (webhookId, limit = 50, offset = 0) => {
    let data = { success: false, data: [], count: 0 };
    await Api.get(`/webhooks/${webhookId}/deliveries?limit=${limit}&offset=${offset}`)
        .then(result => {
            data = result.data;
        })
        .catch(err => {
            data = err.response ? err.response.data : { success: false, errors: [err.message] };
        });
    return data;
};

// Regenerar secret de assinatura do webhook (para webhooks existentes)
export const regenerateWebhookSecret = async (webhookId) => {
    let data = { success: false, data: null };
    await Api.post(`/webhooks/${webhookId}/regenerate-secret`)
        .then(result => {
            data = result.data;
        })
        .catch(err => {
            data = err.response ? err.response.data : { success: false, errors: [err.message] };
        });
    return data;
};

// Gerar secret localmente (para novos webhooks)
export const generateLocalSecret = () => {
    const array = new Uint8Array(32);
    window.crypto.getRandomValues(array);
    return btoa(String.fromCharCode.apply(null, array));
};

// Buscar subscriptions do webhook
export const getWebhookSubscriptions = async (webhookId) => {
    let data = { success: false, data: [] };
    await Api.get(`/webhooks/${webhookId}/subscriptions`)
        .then(result => {
            data = result.data;
        })
        .catch(err => {
            data = err.response ? err.response.data : { success: false, errors: [err.message] };
        });
    return data;
};

// Atualizar subscriptions do webhook
export const updateWebhookSubscriptions = async (webhookId, eventTypeIds) => {
    let data = { success: false };
    await Api.put(`/webhooks/${webhookId}/subscriptions`, { eventTypeIds })
        .then(result => {
            data = result.data;
        })
        .catch(err => {
            data = err.response ? err.response.data : { success: false, errors: [err.message] };
        });
    return data;
};

// Buscar variaveis disponiveis para um tipo de evento
export const getEventVariables = async (eventTypeId) => {
    let data = { success: false, data: [] };
    await Api.get(`/webhooks/event-types/${eventTypeId}/variables`)
        .then(result => {
            data = result.data;
        })
        .catch(err => {
            data = err.response ? err.response.data : { success: false, errors: [err.message] };
        });
    return data;
};

// Preview do payload customizado
export const previewPayload = async (eventTypeId, payloadFormat, customPayloadTemplate) => {
    let data = { success: false, data: null };
    await Api.post('/webhooks/payload/preview', {
        eventTypeId,
        payloadFormat,
        customPayloadTemplate
    })
        .then(result => {
            data = result.data;
        })
        .catch(err => {
            data = err.response ? err.response.data : { success: false, errors: [err.message] };
        });
    return data;
};

// Atualizar payload template de uma subscription
export const updateSubscriptionPayload = async (webhookId, subscriptionId, payloadFormat, customPayloadTemplate) => {
    let data = { success: false, data: null };
    await Api.put(`/webhooks/${webhookId}/subscriptions/${subscriptionId}/payload`, {
        payloadFormat,
        customPayloadTemplate
    })
        .then(result => {
            data = result.data;
        })
        .catch(err => {
            data = err.response ? err.response.data : { success: false, errors: [err.message] };
        });
    return data;
};

// ============================================================
// Response References (S3.1) — mappings de captura do response do webhook.
// Cada mapping define UM par (JSONPath, external_key_name) que sera extraido do
// response body de todo delivery 2xx e gravado como correlacao com a entidade Mexx.
// ATENCAO: API retorna JSON em lowercase (LowercaseContractResolver). Sempre acessar
// campos como .jsonpath, .externalkeyname, .externalentitytype — nunca camelCase.
// ============================================================

export const getWebhookResponseMappings = async (webhookId) => {
    let data = { success: false, data: [] };
    await Api.get(`/webhooks/${webhookId}/response-mappings`)
        .then(result => { data = result.data; })
        .catch(err => { data = err.response ? err.response.data : { success: false, errors: [err.message] }; });
    return data;
};

export const createWebhookResponseMapping = async (webhookId, mapping) => {
    let data = { success: false, data: null };
    await Api.post(`/webhooks/${webhookId}/response-mappings`, mapping)
        .then(result => { data = result.data; })
        .catch(err => { data = err.response ? err.response.data : { success: false, errors: [err.message] }; });
    return data;
};

export const updateWebhookResponseMapping = async (webhookId, mappingId, mapping) => {
    let data = { success: false, data: null };
    await Api.put(`/webhooks/${webhookId}/response-mappings/${mappingId}`, mapping)
        .then(result => { data = result.data; })
        .catch(err => { data = err.response ? err.response.data : { success: false, errors: [err.message] }; });
    return data;
};

export const deleteWebhookResponseMapping = async (webhookId, mappingId) => {
    let data = { success: false };
    await Api.delete(`/webhooks/${webhookId}/response-mappings/${mappingId}`)
        .then(result => { data = result.data; })
        .catch(err => { data = err.response ? err.response.data : { success: false, errors: [err.message] }; });
    return data;
};

// Auto-discovery (S2.4): recebe { deliveryLogId?, responseBody? } e retorna
// { source, sourcedeliverylogid, paths[{jsonpath, samplevalue, suggestedkeyname, suggestedtype}], responsebodypreview }
export const discoverWebhookResponsePaths = async (webhookId, options = {}) => {
    let data = { success: false, data: null };
    await Api.post(`/webhooks/${webhookId}/discover-response-paths`, {
        deliveryLogId: options.deliveryLogId ?? null,
        responseBody: options.responseBody ?? null
    })
        .then(result => { data = result.data; })
        .catch(err => { data = err.response ? err.response.data : { success: false, errors: [err.message] }; });
    return data;
};

// Ultimas execucoes reais (S2.5) pro dropdown "Usar ultima execucao"
export const getWebhookLastResponses = async (webhookId, limit = 5) => {
    let data = { success: false, data: [] };
    await Api.get(`/webhooks/${webhookId}/last-responses?limit=${limit}`)
        .then(result => { data = result.data; })
        .catch(err => { data = err.response ? err.response.data : { success: false, errors: [err.message] }; });
    return data;
};

// External references de uma entidade interna (S3.3 — aba "Integracoes Externas" do chamado)
// entityType: "called" | "chat" | "user"
export const getExternalReferencesByInternal = async (entityType, entityId) => {
    let data = { success: false, data: [] };
    await Api.get(`/entity-references/by-internal/${entityType}/${entityId}`)
        .then(result => { data = result.data; })
        .catch(err => { data = err.response ? err.response.data : { success: false, errors: [err.message] }; });
    return data;
};
